import './App.css';
import '@mantine/core/styles.css';
import Login from './Pages/Auth/Login';
import { Route, Routes } from 'react-router-dom';
import { NavbarNested } from './Layouts/Sidenavbar';
import { NavbarNesteddist } from './Layouts/Sidenavbardist';
import { NavbarNestedadmin } from './Layouts/Adminsidenavbar';
import Accountsetings from './Pages/Accountseting';
import Payout from './Pages/Services/payout';


function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/home-retailer' element={<NavbarNested />} />
        <Route path='/home-distributor' element={<NavbarNesteddist />} />
        <Route path='/home-admin' element={<NavbarNestedadmin />} />
        <Route path='/user-account-settings' element={<Accountsetings />} />
        <Route path='/service/payment-transfer' element={<Payout />} />
      </Routes>

    </>
  );
}

export default App;
